"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBOmnibar = void 0;
var auth_1 = require("../auth");
var interop_1 = require("../shared/interop");
var navigator_1 = require("../shared/navigator");
var dom_utility_1 = require("../shared/dom-utility");
var omnibar_user_activity_1 = require("./omnibar-user-activity");
var omnibar_user_activity_prompt_1 = require("./omnibar-user-activity-prompt");
var omnibar_push_notifications_1 = require("./omnibar-push-notifications");
var omnibar_toast_container_1 = require("./omnibar-toast-container");
var omnibar_vertical_1 = require("./omnibar-vertical");
var CLS_EXPANDED = 'sky-omnibar-iframe-expanded';
var CLS_LOADING = 'sky-omnibar-loading';
var CLS_ENVIRONMENT_VISIBLE = 'sky-omnibar-environment-visible';
var CLS_ENVIRONMENT_DESCRIPTION_VISIBLE = 'sky-omnibar-environment-description-present';
var HOST_ID = 'omnibar';
var OMNIBAR_HEIGHT = 50;
var ENVIRONMENT_HEIGHT = 24;
var envEl;
var envNameEl;
var envDescEl;
var placeholderEl;
var styleEl;
var iframeEl;
var omnibarConfig;
var currentLegacyKeepAliveUrl;
var promiseResolve;
var unreadNotificationCount;
var serviceName;
var currentTitleParts;
function addIframeEl() {
    iframeEl = dom_utility_1.BBAuthDomUtility.addIframe(buildOmnibarUrl(), "sky-omnibar-iframe ".concat(CLS_LOADING), 'Navigation');
}
function isModernTheme() {
    var qs = parseQuerystring();
    if (qs.modernnav === '1') {
        return true;
    }
    var theme = omnibarConfig.theme;
    return theme && theme.name === 'modern';
}
function handleEnvironmentElTheme(isModern) {
    var defaultThemeClass = 'sky-omnibar-environment-theme-default';
    var modernThemeClass = 'sky-omnibar-environment-theme-modern';
    if (isModern) {
        envEl.classList.remove(defaultThemeClass);
        envEl.classList.add(modernThemeClass);
    }
    else {
        envEl.classList.remove(modernThemeClass);
        envEl.classList.add(defaultThemeClass);
    }
}
function addEnvironmentEl() {
    envEl = document.createElement('div');
    envEl.className = 'sky-omnibar-environment';
    handleEnvironmentElTheme(isModernTheme());
    envNameEl = document.createElement('span');
    envNameEl.className = 'sky-omnibar-environment-name';
    envEl.appendChild(envNameEl);
    envDescEl = document.createElement('span');
    envDescEl.className = 'sky-omnibar-environment-description';
    envEl.appendChild(envDescEl);
    dom_utility_1.BBAuthDomUtility.addElToBodyTop(envEl);
}
function collapseIframe() {
    iframeEl.classList.remove(CLS_EXPANDED);
}
function showVerticalNav() {
    if (isModernTheme()) {
        if (omnibarConfig.svcId === 'tcs') {
            return true;
        }
        var qs = parseQuerystring();
        return qs.leftnav === '1';
    }
    return false;
}
function parseQuerystring() {
    var queryParams = {};
    var qs = interop_1.BBAuthInterop.getCurrentUrl().split('?')[1];
    if (qs) {
        if (qs.indexOf('#') >= 0) {
            qs = qs.split('#')[0];
        }
        for (var _i = 0, _a = qs.split('&'); _i < _a.length; _i++) {
            var p = _a[_i];
            var param = p.split('=');
            var key = param[0];
            var value = param[1];
            queryParams[key] = value;
        }
    }
    return queryParams;
}
function addStyleEl() {
    var accentCss = 'background: linear-gradient(to right, #71bf44 0, #31b986 50%, #00b2ec 100%);';
    var accentHeight = '5px';
    var backgroundColor = '#4d5259';
    var borderBottom = 'none';
    var theme = omnibarConfig.theme;
    if (theme) {
        if (isModernTheme()) {
            accentHeight = '4px';
            backgroundColor = '#fff';
            borderBottom = 'solid 1px #e2e3e4';
        }
        var accent = theme.accent;
        backgroundColor = theme.backgroundColor || backgroundColor;
        // Explicitly check for false here since undefined represents the default
        // behavior of showing the accent with the default color.
        if (accent === false) {
            accentCss = 'display: none;';
        }
        else if (accent && accent.color) {
            accentCss = "background-color: ".concat(accent.color, ";");
        }
    }
    styleEl = dom_utility_1.BBAuthDomUtility.addCss("\nbody {\n  margin-top: ".concat(OMNIBAR_HEIGHT, "px;\n}\n\n#bb-help-container {\n  padding-top: 1px;\n}\n\n.sky-omnibar-iframe,\n.sky-omnibar-placeholder {\n  border: none;\n  height: ").concat(OMNIBAR_HEIGHT, "px;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n\n.sky-omnibar-placeholder {\n  background-color: ").concat(backgroundColor, ";\n  border-bottom: ").concat(borderBottom, ";\n  display: none;\n}\n\n.sky-omnibar-placeholder-accent {\n  height: ").concat(accentHeight, ";\n  ").concat(accentCss, "\n}\n\n.sky-omnibar-placeholder.").concat(CLS_LOADING, " {\n  display: block;\n}\n\n.sky-omnibar-iframe.").concat(CLS_LOADING, " {\n  visibility: hidden;\n}\n\n.").concat(CLS_EXPANDED, " {\n  height: 100%;\n}\n\n.sky-omnibar-environment {\n  font-family: \"Blackbaud Sans\", \"Open Sans\", \"Helvetica Neue\", Arial, sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  height: 0;\n  line-height: ").concat(ENVIRONMENT_HEIGHT, "px;\n  overflow: hidden;\n  padding: 0 15px;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sky-omnibar-environment-theme-default {\n  background-color: #e1e1e3;\n  color: #282b31;\n}\n\n.sky-omnibar-environment-theme-modern {\n  background-color: transparent;\n  color: inherit;\n}\n\n.sky-omnibar-environment-description {\n  margin-left: 15px;\n  font-weight: bold;\n}\n\n.").concat(CLS_ENVIRONMENT_DESCRIPTION_VISIBLE, " {\n  background-color: #ffeccf;\n  border-bottom: 2px solid #fbb034;\n  color: #282b31;\n}\n\n.").concat(CLS_ENVIRONMENT_VISIBLE, " .sky-omnibar-environment {\n  height: ").concat(ENVIRONMENT_HEIGHT, "px;\n}\n"));
    updateSize();
}
function addPlaceholderEl() {
    placeholderEl = document.createElement('div');
    placeholderEl.className = "sky-omnibar-placeholder ".concat(CLS_LOADING);
    placeholderEl.innerHTML = "<div class=\"sky-omnibar-placeholder-accent\"></div>";
    document.body.appendChild(placeholderEl);
}
function expandIframe() {
    iframeEl.classList.add(CLS_EXPANDED);
}
function handleStateChange() {
    var _a;
    var url = interop_1.BBAuthInterop.getCurrentUrl();
    var path = interop_1.BBAuthInterop.getCurrentPath();
    var routeInfo = (_a = omnibarConfig.getRouteDetails) === null || _a === void 0 ? void 0 : _a.call(omnibarConfig, {
        href: url,
        pathname: path,
    });
    interop_1.BBAuthInterop.postLocationChangeMessage(iframeEl, url, routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.category);
    omnibar_toast_container_1.BBOmnibarToastContainer.updateUrl(url);
    omnibar_vertical_1.BBOmnibarVertical.updateUrl(url, routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.category);
}
function handleSearch(searchArgs) {
    return __awaiter(this, void 0, void 0, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!omnibarConfig.onSearch) return [3 /*break*/, 2];
                    return [4 /*yield*/, omnibarConfig.onSearch(searchArgs)];
                case 1:
                    results = _a.sent();
                    interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                        messageType: 'search-results',
                        results: results,
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function updateSize() {
    if (omnibarConfig.onResize) {
        omnibarConfig.onResize({
            position: 'top',
            size: OMNIBAR_HEIGHT +
                (document.body.classList.contains(CLS_ENVIRONMENT_VISIBLE) ? 24 : 0),
        });
    }
}
function openPushNotificationsMenu() {
    interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
        messageType: 'push-notifications-open',
    });
}
function notificationsCallback(notifications) {
    interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
        messageType: 'push-notifications-update',
        pushNotifications: notifications,
    });
    omnibar_toast_container_1.BBOmnibarToastContainer.showNewNotifications(notifications);
    unreadNotificationCount =
        notifications &&
            notifications.notifications &&
            notifications.notifications.filter(function (notification) { return !notification.isRead; })
                .length;
    updateTitle();
}
function customMessageCallback(message) {
    omnibar_vertical_1.BBOmnibarVertical.refreshSettings(message.value);
}
function connectPushNotifications(checkLoggedIn) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!checkLoggedIn) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, auth_1.BBAuth.getToken({
                            disableRedirect: true,
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    return [2 /*return*/];
                case 4:
                    if (!omnibarConfig) return [3 /*break*/, 6];
                    return [4 /*yield*/, omnibar_push_notifications_1.BBOmnibarPushNotifications.connect({
                            customMessageCallback: customMessageCallback,
                            envId: omnibarConfig.envId,
                            handleNavigate: handleNavigate,
                            handleNavigateUrl: handleNavigateUrl,
                            handlePushNotificationsChange: handlePushNotificationsChange,
                            leId: omnibarConfig.leId,
                            notificationsCallback: notificationsCallback,
                            openPushNotificationsMenu: openPushNotificationsMenu,
                            showVerticalNav: showVerticalNav(),
                            svcId: omnibarConfig.svcId,
                        })];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function disconnectPushNotifications() {
    omnibar_push_notifications_1.BBOmnibarPushNotifications.disconnect();
}
function refreshUserCallback() {
    return __awaiter(this, void 0, void 0, function () {
        var token, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    auth_1.BBAuth.clearTokenCache();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, auth_1.BBAuth.getToken({
                            disableRedirect: true,
                            forceNewToken: true,
                        })];
                case 2:
                    token = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    return [3 /*break*/, 4];
                case 4:
                    interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                        messageType: 'refresh-user',
                        token: token,
                    });
                    if (showVerticalNav()) {
                        omnibar_vertical_1.BBOmnibarVertical.refreshUser(token);
                    }
                    if (token) {
                        connectPushNotifications();
                    }
                    else {
                        disconnectPushNotifications();
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function showInactivityCallback() {
    omnibar_user_activity_prompt_1.BBOmnibarUserActivityPrompt.show({
        sessionRenewCallback: function () {
            omnibar_user_activity_1.BBOmnibarUserActivity.userRenewedSession();
        },
    });
}
function hideInactivityCallback() {
    omnibar_user_activity_prompt_1.BBOmnibarUserActivityPrompt.hide();
}
function startActivityTracking() {
    omnibar_user_activity_1.BBOmnibarUserActivity.startTracking(refreshUserCallback, showInactivityCallback, hideInactivityCallback, omnibarConfig.allowAnonymous, currentLegacyKeepAliveUrl);
}
function handleHelp() {
    var BBHELP = window.BBHELP;
    if (BBHELP) {
        BBHELP.HelpWidget.open();
    }
}
function handleNotificationRead(notification) {
    var notificationsConfig = omnibarConfig.notifications;
    if (notificationsConfig && notificationsConfig.onNotificationRead) {
        notificationsConfig.onNotificationRead(notification);
    }
}
function handlePushNotificationsChange(notifications) {
    omnibar_push_notifications_1.BBOmnibarPushNotifications.updateNotifications(notifications);
}
function handleEnvironmentUpdate(name, description, url) {
    var bodyClassList = document.body.classList;
    name = name || '';
    envNameEl.innerText = name;
    if (name) {
        bodyClassList.add(CLS_ENVIRONMENT_VISIBLE);
        if (description) {
            envEl.classList.add(CLS_ENVIRONMENT_DESCRIPTION_VISIBLE);
            if (url) {
                var a = document.createElement('a');
                a.href = url;
                a.innerText = description;
                envDescEl.appendChild(a);
            }
            else {
                envDescEl.innerText = description;
            }
        }
        else {
            envEl.classList.remove(CLS_ENVIRONMENT_DESCRIPTION_VISIBLE);
        }
    }
    else {
        bodyClassList.remove(CLS_ENVIRONMENT_VISIBLE);
    }
    updateSize();
}
function handleBrandingUpdate(branding) {
    var _a, _b;
    var favIconUrl = (_b = (_a = branding === null || branding === void 0 ? void 0 : branding.images) === null || _a === void 0 ? void 0 : _a.favIcon) === null || _b === void 0 ? void 0 : _b.url;
    if (favIconUrl) {
        // Update the hrefs that we can support.
        document
            .querySelectorAll("link[rel='icon'], link[rel='apple-touch-icon']")
            .forEach(function (linkEl) {
            linkEl.href = favIconUrl;
        });
        // Remove the elements that we can't support so there's no lingering default logo anywhere.
        document
            .querySelectorAll("link[rel='mask-icon'], link[rel='manifest']")
            .forEach(function (linkEl) {
            linkEl.remove();
        });
    }
}
function handleNavigate(navItem) {
    interop_1.BBAuthInterop.handleNavigate(omnibarConfig.nav, navItem);
}
function handleNavigateUrl(url) {
    navigator_1.BBAuthNavigator.navigate(url);
}
function monkeyPatchState() {
    var oldPushState = history.pushState;
    var oldReplaceState = history.replaceState;
    function newPushState() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = oldPushState.apply(history, args);
        handleStateChange();
        return result;
    }
    function newReplaceState() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = oldReplaceState.apply(history, args);
        handleStateChange();
        return result;
    }
    history.pushState = newPushState;
    history.replaceState = newReplaceState;
}
function initLocalNotifications() {
    var notificationsConfig = omnibarConfig.notifications;
    if (notificationsConfig) {
        notificationsConfig.onReady({
            updateNotifications: function (notifications) {
                interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                    messageType: 'notifications-update',
                    notifications: notifications,
                });
            },
        });
    }
}
function messageHandler(event) {
    var message = event.data;
    if (!interop_1.BBAuthInterop.messageIsFromOmnibar(event) ||
        message.hostId !== HOST_ID) {
        return;
    }
    var nav = omnibarConfig.nav;
    switch (message.messageType) {
        case 'ready':
            // Notify the omnibar of the host page's origin.  This MUST be the first
            // message that is posted to the omnibar because all other messages will
            // be validated against the provided origin.  If the origin of the host page
            // does not match a whilelist of allowed origins maintained by the omnibar,
            // further communications between the omnibar and host will be blocked.
            interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                messageType: 'host-ready',
            });
            monkeyPatchState();
            interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                compactNavOnly: omnibarConfig.compactNavOnly || showVerticalNav(),
                enableHelp: omnibarConfig.enableHelp,
                envId: omnibarConfig.envId,
                hideResourceLinks: omnibarConfig.hideResourceLinks,
                leId: omnibarConfig.leId,
                localNavItems: nav && nav.localNavItems,
                localNotifications: !!omnibarConfig.notifications,
                localSearch: !!omnibarConfig.onSearch,
                messageType: 'nav-ready',
                navVersion: omnibarConfig.navVersion,
                services: nav && nav.services,
                svcId: omnibarConfig.svcId,
                theme: omnibarConfig.theme,
            });
            initLocalNotifications();
            connectPushNotifications(true);
            handleStateChange();
            promiseResolve();
            break;
        case 'display-ready':
            placeholderEl.classList.remove(CLS_LOADING);
            iframeEl.classList.remove(CLS_LOADING);
            break;
        case 'expand':
            expandIframe();
            break;
        case 'collapse':
            collapseIframe();
            break;
        case 'navigate-url':
            handleNavigateUrl(message.url);
            break;
        case 'navigate':
            handleNavigate(message.navItem);
            break;
        case 'search':
            handleSearch(message.searchArgs);
            break;
        case 'get-token':
            interop_1.BBAuthInterop.handleGetToken(iframeEl, message.tokenRequestId, message.disableRedirect, startActivityTracking);
            break;
        case 'help-open':
            handleHelp();
            break;
        case 'notification-read':
            handleNotificationRead(message.notification);
            break;
        case 'push-notifications-change':
            handlePushNotificationsChange(message.notifications);
            break;
        case 'session-renew':
            omnibar_user_activity_1.BBOmnibarUserActivity.userRenewedSession();
            break;
        case 'environment-update':
            handleEnvironmentUpdate(message.name, message.description, message.url);
            break;
        case 'branding-update':
            handleBrandingUpdate(message.branding);
            break;
        case 'legacy-keep-alive-url-change':
            currentLegacyKeepAliveUrl = message.url;
            startActivityTracking();
            break;
        case 'selected-service-update':
            serviceName = message.serviceName;
            updateTitle();
            break;
    }
}
function buildOmnibarUrl() {
    var omnibarUrl = omnibarConfig.url ||
        /* istanbul ignore next */
        'https://host.nxt.blackbaud.com/omnibar/';
    return (omnibarUrl + (omnibarUrl.indexOf('?') < 0 ? '?' : '&') + "hostid=".concat(HOST_ID));
}
function updateTitle() {
    if (currentTitleParts) {
        var titleParts = currentTitleParts.slice();
        if (serviceName) {
            titleParts.push(serviceName);
        }
        var title = titleParts.join(' - ');
        if (unreadNotificationCount) {
            title = "(".concat(unreadNotificationCount, ") ").concat(title);
        }
        document.title = title;
    }
}
var BBOmnibar = /** @class */ (function () {
    function BBOmnibar() {
    }
    BBOmnibar.load = function (config) {
        omnibarConfig = omnibarConfig = config;
        // TODO: Deprecate this and only allow it to come from the legacy-keep-alive-url-change message
        // from the omnibar.
        currentLegacyKeepAliveUrl = omnibarConfig.legacyKeepAliveUrl;
        return new Promise(function (resolve) {
            promiseResolve = resolve;
            addStyleEl();
            addPlaceholderEl();
            // Add these in reverse order since each will be inserted at the top of the
            // document; this will ensure the proper order in the DOM.
            addEnvironmentEl();
            addIframeEl();
            if (showVerticalNav()) {
                omnibar_vertical_1.BBOmnibarVertical.load(config, iframeEl);
            }
            window.addEventListener('message', messageHandler);
        });
    };
    BBOmnibar.update = function (args) {
        interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
            messageType: 'update',
            updateArgs: args,
        });
        if (args.theme) {
            handleEnvironmentElTheme(args.theme.name === 'modern');
        }
    };
    BBOmnibar.setTitle = function (args) {
        currentTitleParts = args && args.titleParts;
        updateTitle();
    };
    BBOmnibar.pushNotificationsEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!omnibarConfig) {
                    return [2 /*return*/, Promise.resolve(false)];
                }
                return [2 /*return*/, omnibar_push_notifications_1.BBOmnibarPushNotifications.pushNotificationsEnabled()];
            });
        });
    };
    BBOmnibar.destroy = function () {
        omnibar_toast_container_1.BBOmnibarToastContainer.destroy();
        omnibar_push_notifications_1.BBOmnibarPushNotifications.disconnect();
        dom_utility_1.BBAuthDomUtility.removeEl(placeholderEl);
        dom_utility_1.BBAuthDomUtility.removeEl(iframeEl);
        dom_utility_1.BBAuthDomUtility.removeEl(envEl);
        dom_utility_1.BBAuthDomUtility.removeCss(styleEl);
        window.removeEventListener('message', messageHandler);
        document.body.classList.remove(CLS_ENVIRONMENT_VISIBLE);
        omnibarConfig =
            styleEl =
                placeholderEl =
                    iframeEl =
                        envEl =
                            envDescEl =
                                envNameEl =
                                    promiseResolve =
                                        unreadNotificationCount =
                                            currentTitleParts =
                                                serviceName =
                                                    undefined;
    };
    return BBOmnibar;
}());
exports.BBOmnibar = BBOmnibar;
